import { NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../home/Home.css";
import "../home/Responsive.css"

import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";

import AuthModal from "../auth/AuthModal";
import GuideAuth from "../auth/GuideAuth";
import { getUserData, removeUserData } from "../utils/storage";
import { userLogout } from "../services/authService";

import ReusableModal from "../common/ReusableModal"

function Header() {
  const user = getUserData("safarix_user");
  const guide = getUserData("guide");
  const driver = getUserData("driver");

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showUserLogin, setShowUserLogin] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileMenuRef = useRef(null);
  const location = useLocation();

  const isTransparentHeader =
    location.pathname === "/" || location.pathname === "/hotel";

  const handleProfileClick = async () => {
    if (user) {
      navigate("/user-dashboard")
    } else {
      setShowUserLogin(!showUserLogin)
    }
  }

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    dispatch(logout());
    removeUserData("safarix_user");
    removeUserData("safarix_token");
    removeUserData("safarix_refreshtoken");
    setShowLogoutModal(false);
    window.location.reload(true);

  };

  const handleDriverLogout = async () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (!confirmed) return;

    setShowProfileMenu(false);
    // await driverGuideLogout();
    removeUserData("driver");
    removeUserData("driver_token");
    removeUserData("driver_refreshtoken");
    dispatch(logout());
    window.location.reload(true);
  };

  const handleGuideLogout = async () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (!confirmed) return;

    setShowProfileMenu(false);
    // await driverGuideLogout();
    removeUserData("guide");
    removeUserData("guide_token");
    removeUserData("guide_refreshtoken");
    dispatch(logout());
    navigate("/");
    // window.location.reload(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isTransparentHeader) return; // scroll listener sirf home/hotel me lagega

    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isTransparentHeader]);

  return (
    <div>
      <header className="sticky-top">
        <div className="container">

          {/* Top Row */}
          <div className="d-flex align-items-center justify-content-between">

            {/* Logo */}
            <a className="navbar-brand" href="/">
              <img
                src="/Images/black-logo.png"
                alt="Safarix Logo"
                height="45"
              />
            </a>

            {/* Desktop Navigation */}
            <ul className="nav header-nav d-none d-md-flex">
              <li className="nav-item">
                <NavLink
                  to="/flights"
                  className={({ isActive }) =>
                    "nav-link" +
                    (isActive || location.pathname === "/" ? " active" : "")
                  }
                >
                  <i className="bi bi-airplane"></i> FLIGHT
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/hotel"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  <i className="bi bi-building"></i> HOTEL
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/bus"
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  <i className="bi bi-bus-front-fill"></i> BUS
                </NavLink>
              </li>
            </ul>

            {/* Profile */}
            <div className="d-flex align-items-center">
              <div className="profile-wrapper me-2" ref={profileMenuRef}>
                <div className="profile-icon-link" onClick={handleProfileClick}>
                  <i className="bi bi-person"></i>
                </div>
              </div>

              {user && (
                <div onClick={handleLogoutClick} className="profile-icon-link">
                  <i className="bi bi-box-arrow-right"></i>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Navigation Cards */}
          <div className="row g-2 mt-2 d-md-none">

            <div className="col-4">
              <NavLink to="/flights" className="mobile-nav-card">
                <i className="bi bi-airplane"></i>
                <span>FLIGHT</span>
              </NavLink>
            </div>

            <div className="col-4">
              <NavLink to="/hotel" className="mobile-nav-card">
                <i className="bi bi-building"></i>
                <span>HOTEL</span>
              </NavLink>
            </div>

            <div className="col-4">
              <NavLink to="/bus" className="mobile-nav-card">
                <i className="bi bi-bus-front"></i>
                <span>BUS</span>
              </NavLink>
            </div>

          </div>

          <AuthModal
            show={showUserLogin}
            onClose={() => setShowUserLogin(false)}
            setShowUserLogin={setShowUserLogin}
          />

        </div>


      </header>

      <ReusableModal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        okText="Yes, Logout"
        cancelText="Cancel"
        onOk={confirmLogout}
      />
    </div>
  );
}

export default Header;
